import styled from '@emotion/styled';

export const Result = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);
`;

export const P = styled.p`
  padding: 0 var(--spacing-16);

  @media (min-width: 600px) {
    padding-left: var(--spacing-24);
    padding-right: var(--spacing-24);
  }
`;
